import { initializeApp } from "firebase/app";
import { getAnalytics, isSupported, logEvent } from "firebase/analytics";
import {
  getAuth,
  GoogleAuthProvider,
  signInWithPopup,
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  signOut,
  onAuthStateChanged
} from "firebase/auth";
import {
  getFirestore,
  doc,
  setDoc,
  serverTimestamp,
  collection,
  onSnapshot
} from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyDfowPWknqVj0LIa4sdR3MAa4UufLvj_tk",
  authDomain: "indexairium.firebaseapp.com",
  projectId: "indexairium",
  storageBucket: "indexairium.firebasestorage.app",
  messagingSenderId: "552632156202",
  appId: "1:552632156202:web:d94e3b8ee92d65af4f4353",
  measurementId: "G-9ZP7Y8N3R8"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const googleProvider = new GoogleAuthProvider();

let analyticsInstance = null;

async function initAnalytics() {
  if (analyticsInstance || typeof window === "undefined") {
    return analyticsInstance;
  }

  const supported = await isSupported();
  if (!supported) {
    return null;
  }

  analyticsInstance = getAnalytics(app);
  return analyticsInstance;
}

async function trackPageView(path = window.location.pathname) {
  const analytics = await initAnalytics();
  if (!analytics) {
    return;
  }

  logEvent(analytics, "page_view", {
    page_location: window.location.href,
    page_path: path,
    page_title: document.title
  });
}

export {
  auth,
  initAnalytics,
  trackPageView,
  db,
  doc,
  setDoc,
  serverTimestamp,
  collection,
  onSnapshot,
  googleProvider,
  signInWithPopup,
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  signOut,
  onAuthStateChanged
};

export default app;
